import './utils/tz';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider, Spin } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { tenantRouter } from './routes/tenant';
import { useTenantAuth } from './stores/auth.tenant';
import { tenantApi } from './api/tenant';
import { TenantSessionChangedError, readStoredTenantJwt } from './utils/tenant-session';

const qc = new QueryClient({
  // refetchOnMount:'always' → 每次进/切回页面都后台拉最新（缓存先秒显示、随即刷新），
  // 解决「别处改了数据、staleTime(60s) 内切回看到旧数据」。staleTime 保留用于并发去重。
  defaultOptions: { queries: { retry: (count, error) => !(error instanceof TenantSessionChangedError) && count < 1, refetchOnWindowFocus: false, refetchOnMount: 'always', staleTime: 60_000 } },
});

const { jwt, tenant } = useTenantAuth.getState();
if (window.location.pathname !== '/delegated-entry' && jwt && !tenant) {
  tenantApi.getProfile()
    .then((t) => useTenantAuth.getState().commitIfCurrent(jwt, () => useTenantAuth.getState().setTenant(t)))
    .catch((error) => {
      if (error instanceof TenantSessionChangedError) return;
      const state = useTenantAuth.getState();
      if (state.jwt === jwt && readStoredTenantJwt() === jwt) state.logoutIfCurrent(jwt);
    });
}

// Suspense 兜底所有路由级 React.lazy 的挂起：初次进入/硬刷新 lazy 路由时显示加载态，
// 杜绝「lazy 组件无 Suspense 边界 → 同步挂起 → React #426」那类崩溃（站内跳转走 RR transition 不闪）。
const PageLoading = (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <Spin size="large" />
  </div>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ConfigProvider locale={zhCN}>
    <QueryClientProvider client={qc}>
      <Suspense fallback={PageLoading}>
        <RouterProvider router={tenantRouter} />
      </Suspense>
    </QueryClientProvider>
  </ConfigProvider>
);
